var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 6,
    fill: "#DEFEE4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2616 17.2843C19.2616 17.2843 18.3573 18.1725 18.1357 18.4329C17.7747 18.8181 17.3494 19 16.7918 19C16.7382 19 16.681 19 16.6274 18.9964C15.5659 18.9287 14.5794 18.5149 13.8395 18.1618C11.8165 17.1845 10.0402 15.7969 8.56403 14.0385C7.34523 12.5725 6.53032 11.2171 5.99062 9.76178C5.65822 8.87363 5.5367 8.18166 5.59031 7.52892C5.62605 7.11159 5.78689 6.76561 6.08355 6.46955L7.30234 5.25325C7.47748 5.08917 7.66333 5 7.84562 5C8.07079 5 8.25307 5.13554 8.36745 5.24968C8.37102 5.25325 8.3746 5.25682 8.37817 5.26038C8.5962 5.46369 8.8035 5.67414 9.02152 5.89885C9.13232 6.01299 9.2467 6.12713 9.36107 6.24484L10.3368 7.2186C10.7157 7.59669 10.7157 7.94624 10.3368 8.32433C10.2332 8.42777 10.1331 8.53121 10.0294 8.63108C9.72921 8.93783 9.96506 8.70247 9.65411 8.98068C9.64696 8.98782 9.63981 8.99138 9.63624 8.99852C9.32886 9.30527 9.38604 9.60489 9.45038 9.8082C9.45395 9.8189 9.45753 9.8296 9.4611 9.8403C9.71487 10.4538 10.0723 11.0316 10.6156 11.72L10.6191 11.7236C11.6056 12.9364 12.6457 13.8816 13.793 14.6056C13.9396 14.6984 14.0897 14.7733 14.2326 14.8446C14.3613 14.9088 14.4828 14.9695 14.5865 15.0337C14.6008 15.0408 14.6151 15.0515 14.6294 15.0586C14.7509 15.1193 14.8653 15.1478 14.9832 15.1478C15.2799 15.1478 15.4657 14.9623 15.5265 14.9017L16.2271 14.2025C16.3486 14.0813 16.5416 13.935 16.7668 13.935C16.9884 13.935 17.1707 14.0741 17.2815 14.1954C17.285 14.199 17.285 14.199 17.2886 14.2025L19.258 16.1679C19.6261 16.5317 19.2616 17.2843 19.2616 17.2843Z",
    stroke: "#0ACD95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPhone);
export default __webpack_public_path__ + "static/media/info-phone.697521130edb20fb9b0aed1158a2c011.svg";
export { ForwardRef as ReactComponent };